import { Injectable } from '@angular/core';
import { Actions as EffectActions, createEffect, ofType } from '@ngrx/effects';
import { ActionType } from './store/actions/users.actions';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as Actions from './store/actions/users.actions';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root'
})
export class UsersEffects {

  url = 'https://localhost:44358';

  constructor(
    private usersService: UsersService,
    private actions$: EffectActions,
    private http: HttpClient
  ) { }

  
  fetchUsersRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_USERS),
      mergeMap((action: Actions.FetchUsers) => {

        return this.usersService.getUsers$()
          .pipe(
            mergeMap((response: any) => {
              console.log('fetchUsersRequest...', response);
              return ([
                new Actions.FetchUsersSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchUsersFailed(err));
            })

          );
      })
    ));

    
    fetchUsersByCompanyIdRequestFirebase = createEffect(() => this.actions$
      .pipe(
        ofType(ActionType.FETCH_USERS_BY_COMPANYID),
        mergeMap((action: Actions.FetchUsersByCompanyId) => {

          return this.usersService.getUsersByCompanyId$(action.companyId)
            .pipe(
              mergeMap((response: any) => {
                console.log('fetchUsersRequestByCompanyId...', response);
                return ([
                  new Actions.FetchUsersByCompanyIdSuccess(response)
                ]);
              }
              ),
              catchError(err => {
                console.log('Handling error locally and rethrowing it...', err);
                return of(new Actions.FetchUsersByCompanyIdFailed(err));
              })

            );
        })
      ));
  // @Effect()
  // fetchUsersRequest = this.actions$
  //   .pipe(
  //     ofType(ActionType.FETCH_USERS),
  //     mergeMap((action: Actions.FetchUsers) => {

  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.usersService.getUsers$()
  //         .pipe(
  //           mergeMap((response: any) => {

  //             return ([
  //               new Actions.FetchUsersSuccess(response)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.FetchUsersFailed(err));
  //           })

  //         );
  //     })
  //   );

    
    updateUser = createEffect(() => this.actions$
      .pipe(
        ofType(ActionType.UPDATE_USER),
        mergeMap((action: Actions.UpdateUser) => {

          const message = action.user;
          const id = action.user.id;
          const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

          const user = action.user;

          // return this.http.put<User>(this.url + '/api/Users/' + id, user, httpOptions)
          return this.usersService.updateUser$(action.user)
            .pipe(
              mergeMap((response: any) => {

                console.log('response updateUser...', user);
                return ([
                  new Actions.UpdateUserSuccess(id, user)
                ]);
              }
              ),
              catchError(err => {
                console.log('Handling error locally and rethrowing it...', err);
                return of(new Actions.UpdateUserFailed());
              })

            );
        })
      ));
}
